import type { FunctionComponent } from 'react';

import { createClassName, createStyleHelper } from '../../utils/class-names';
import { Icon } from '../icon/icon';

import styles from './arrows.module.scss';

const style = createStyleHelper(styles, 'arrows');

export interface IArrowsProps {
    className?: string;
    status?: boolean;
}

export const ArrowsComponent: FunctionComponent<IArrowsProps> = ({ className, status }) => {
    return (
        <div className={createClassName([className, style()])}>
            {status ? (
                <Icon
                    className={style('arrow-icon', {
                        active: true,
                    })}
                    name={'angle-up'}
                />
            ) : (
                <Icon className={style('arrow-icon')} name={'angle-down'} />
            )}
        </div>
    );
};
